import { Box, IconButton, Modal, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { ArrowBack } from '@mui/icons-material';
import clsx from 'clsx';
import useWindowWidth from '../../hooks/useWindowWidth';

const getModalStyle = (windowWidth, fullScreenMobile) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: windowWidth < 768 ? '100%' : '90%',
    maxWidth: windowWidth < 768 ? (fullScreenMobile ? 768 : 550) : 550,
    bgcolor: 'var(--common-modal-bg)',
    boxShadow: 24,
    borderRadius: 2,
    p: 3,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    outline: 0,
    ...(windowWidth < 768
        ? fullScreenMobile
            ? {
                  height: '100%',
                  maxHeight: '100vh',
                  p: 0,
                  borderRadius: 0,

              }
            : {
                  maxHeight: '90vh',
                  borderRadius: 0,

              }
        : {
              maxHeight: '90vh',
          }),
});

const JunoModal = ({ 
    onClose, 
    title, 
    content = () => {}, 
    open, 
    showBack, 
    fullScreenMobile,
    showSlide = false 
}) => {
    const windowWidth = useWindowWidth();
    const style = getModalStyle(windowWidth, fullScreenMobile);
    const isMobile = windowWidth < 768;
    
    const shouldUseSlide = isMobile && showSlide;

    const modalContent = (
        <Box sx={!shouldUseSlide ? style : { bgcolor: 'var(--common-modal-bg)',height: '100%',}}>
            {onClose ? (
                <Box
                className={clsx(
                    `jusitfy-around  pb-0 md:justify-between md:p-0 flex`,
                    !showBack && '!justify-between',
                    fullScreenMobile ? 'p-[1rem]' : 'p-0',
                )}
                alignItems="center">
                    {showBack && isMobile ? (
                        <IconButton onClick={onClose} aria-label="back">
                            <ArrowBack className="!text-primary p-0 mr-2" />
                        </IconButton>
                    ) : null}
                    <div className="flex items-center">
                        <h2
                            className="!text-primary text-lg md:text-xl text-uppercase"
                            variant="h6"
                            component="h2"
                            id="modal-title">
                            {title}
                        </h2>
                    </div>

                    {!showBack || !isMobile ? (
                        <IconButton onClick={onClose} aria-label="close">
                            <CloseIcon className="!text-primary" />
                        </IconButton>
                    ) : null}
                </Box>
            ) : null}
            <Box
                className={clsx(
                    isMobile && fullScreenMobile && 'h-full px-3',
                    !fullScreenMobile && 'px-0',
                )}>
                {content()}
            </Box>
        </Box>
    );

    return (
        <Modal open={open} onClose={onClose} >
            {shouldUseSlide ? (
                <Slide direction="up" in={open} mountOnEnter  timeout={800}>
                    {modalContent}
                </Slide>
            ) : (
                
                modalContent
            )}
        </Modal>
    );
};

JunoModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.func,
    showBack: PropTypes.bool,
    fullScreenMobile: PropTypes.bool,
    showSlide: PropTypes.bool,
};

export default JunoModal;